'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _endpoints = require('./config/endpoints');

var _parser = require('./lib/parser');

var _model = require('./lib/model');

var _custom = require('./lib/custom');

var Custom = _interopRequireWildcard(_custom);

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }

    newObj["default"] = obj;
    return newObj;
  }
}

var Thor = {
  _routes: {},
  setup: function setup(_ref) {
    var _ref$token = _ref.token,
        token = _ref$token === undefined ? null : _ref$token,
        _ref$usejQ = _ref.usejQ,
        usejQ = _ref$usejQ === undefined ? false : _ref$usejQ,
        _ref$host = _ref.host,
        host = _ref$host === undefined ? location.origin : _ref$host,
        _ref$hooks = _ref.hooks,
        hooks = _ref$hooks === undefined ? {} : _ref$hooks;
    this._routes = _parser.Parser.prepareCalls(_endpoints.Endpoints, {
      usejQ: usejQ,
      token: token,
      host: host,
      hooks: _extends({
        beforeSend: function beforeSend(_ref2) {
          var qs = _ref2.qs,
              headers = _ref2.headers,
              data = _ref2.data;
          return {
            qs: qs,
            headers: headers,
            data: data
          };
        }
      }, hooks)
    });

    for (var endpoint in _endpoints.Endpoints) {
      var namespace = _endpoints.Endpoints[endpoint].namespace;
      this[namespace] = new _model.Model(this, endpoint, namespace, Custom[endpoint]);
    }
  }
};
exports["default"] = Thor;